import type {Ref} from "vue";

export default class TimeZonePopup {

    private static instance: TimeZonePopup;
    private static creating: boolean = false;
    private showRef: Ref<boolean> | null = null;
    private popupBlock: HTMLElement | null = null;
    private onShowListeners: (() => void)[] = [];
    private readonly localStorageKey = 'TimeZoneShown';

    public isShown(): boolean {
        return localStorage.getItem(this.localStorageKey) === 'true';
    }


    private constructor() {
        if (!TimeZonePopup.creating) {
            throw new Error("You must use TimeZonePopup.getInstance() to create an instance.");
        }

    }

    public addOnShowListener(listener: () => void) {
        this.onShowListeners.push(listener);
    }

    static getInstance(): TimeZonePopup {
        if (!TimeZonePopup.instance) {
            TimeZonePopup.creating = true;
            TimeZonePopup.instance = new TimeZonePopup();
            TimeZonePopup.creating = false;
        }
        return TimeZonePopup.instance;
    }

    public init(showRef: Ref<boolean>, popupBlock: HTMLElement ): void {
        this.showRef = showRef;
        this.popupBlock = popupBlock;
    }


    public showFirstTime() {
        if (!this.isShown()) {
            this.show();
        }
    }

    public show() {
        this.onShowListeners.forEach(listener => listener());
        localStorage.setItem(this.localStorageKey, 'true');
    }

    public hide(): void {
        if (this.showRef) {
            this.showRef.value = false;
        }
    }
}
